import * as Apice from './lib_react_adminlte/main/Apice';
import tabReducer from './lib_react_adminlte/template/tab/tabReducer';
import filiaisReducer from './utils/filialReducer';
import CadastroUsuario from './componentes/CadastroUsuario.jsx';
import Empresa from './componentes/Empresa.jsx';
import Fechamento from './componentes/Fechamento.jsx'
import Api from './utils/Api.jsx';

const opcoes = new Apice.Options();
opcoes.iniciarAberto = true;
opcoes.usarFiltro = true;
opcoes.mudarSenha = true;

Apice.iniciarAplicacao(
  {
    tab: tabReducer,
    filiais: filiaisReducer,
  },
  (reduxState, menuItem) => {
    const itens = [];
    const filtro = reduxState.filtroItens.toUpperCase();
    const arr = reduxState.filiais.filter((x) => {
      const razaoSocial = x.razao_social || "";
      const docFederal = x.doc_federal || "";
      return (
        razaoSocial.toUpperCase().indexOf(filtro) >= 0 ||
        docFederal.toUpperCase().indexOf(filtro) >= 0
      );
    });
    if (reduxState.usuario.tipo === "A") {
      itens.push(
        menuItem("cadastro", "Cadastro usuário", "fa-edit", CadastroUsuario)
      );
    }
    itens.push(menuItem("Fechamento", "Fechamento", "fa-edit", Fechamento));
    // arr.map(x => itens.push(
    //   menuItem('empresas/' + x.doc_federal, x.razao_social, 'fa-folder', Empresa)
    // ));
    return itens;
  },
  "fa-file-archive-o",
  "Ápice Fechamento",
  "apice_fechamento_web",
  //"http://localhost:3001", //LOCAL HOST
  'https://fechamento.apicesistemas.com.br',
  //"http://192.168.1.123:3001",

  opcoes,
  {
    on_login: async (dispatch, state, action) => {
      const ret = await Api.getEmpresaUsuario(state.usuario, "");
      dispatch({
        type: "set_filiais",
        dados: ret.dados,
      });
    },
  }
);

  


// WEBPACK FOOTER //
// ./src/index.js